export const GOOGLE_PRIVACY_POLICY_URL = 'https://policies.google.com/privacy'
export const GOOGLE_SERVICE_TERMS_URL = 'https://policies.google.com/terms'
export const LINK_TARGET_BLANK = '_blank'
export const LINK_REL_NOOPENER = 'noopener'
